import React, { useEffect, useState } from "react";
import { post } from "../../../components/api";
import AutocompleteInput from "../../../components/AutocompleteInput";
import Select from "react-select";
import DatePicker from "react-datepicker";
import axios from "axios";
import RouteMap from "../../../components/loadMap";
import { useLocation } from "react-router-dom";

const UpdateLoadForm = () => {
  const { state } = useLocation();
  const [origin, setOrigin] = useState({ lat: "", lng: "" });
  const [destination, setDestination] = useState({ lat: "", lng: "" });
  const [originAddress, setOriginAddress] = useState("");
  const [destinationAddress, setDestinationAddress] = useState("");
  const [productTypes, setProductTypes] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [tyreSizes, setTyreSizes] = useState([]);
  const [rate, setRate] = useState("");
  const [remark, setRemark] = useState("");
  const [truckCapacities, setTruckCapacities] = useState([]);
  const [vehicleSize, setVehicleSize] = useState([]);
  const [selectedBodyType, setSelectedBodyType] = useState({
    value: "body_type",
    label: "Body Type",
  });
  const [loadingDate, setLoadingDate] = useState(new Date());
  const [deliveryDate, setDeliveryDate] = useState();
  const [selectedProduct, setSelectedProduct] = useState({
    value: "product_type",
    label: "Product Type",
  });
  const [selectedTyre, setSelectedTyre] = useState({
    value: "tyre_type",
    label: "Tyre Type",
  });
  const [selectedTruckCapacity, setSelectedTruckCapacity] = useState({
    value: "truck_capacity",
    label: "Truck Capacity",
  });
  const [selectedVehiclesize, setSelectedVehicleSize] = useState({
    value: "vehicle_size",
    label: "Vehicle Size",
  });
  const [id, setId] = useState("");

  const handlePlaceSelected = (place, inputIdentifier) => {
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const coords = { lat, lng };
    if (inputIdentifier === "origin") {
      setOrigin(coords);
      setOriginAddress(place?.formatted_address);
    } else {
      setDestination(coords);
      setDestinationAddress(place?.formatted_address);
    }
  };

  useEffect(() => {
    // Note the .data access for nested structure.

    // Setting origin and destination
    setId(state?._id);
    setOrigin({
      lat: state?.fromCity.coordinates[0],
      lng: state?.fromCity.coordinates[1],
    });
    setOriginAddress(state?.fromCity.name);
    setDestination({
      lat: state?.toCity.coordinates[0],
      lng: state?.toCity.coordinates[1],
    });
    setDestinationAddress(state?.toCity.name);

    // Setting other states
    setLoadingDate(state?.loadingDate);
    setSelectedProduct(state?.productType);
    setSelectedBodyType(state?.bodyType);
    setSelectedTyre(state?.tyre);
    setSelectedTruckCapacity(state?.truckCapacity);
    setSelectedVehicleSize(state?.vehicleSize);
    setRate(state?.OfferedRate);
    setRemark(state?.remarks);
  }, []);

  const customStyles = {
    control: (base) => ({
      ...base,
      background: "rgba(242, 243, 244, 0.5)",
      border: "none",
      outline: "none",
      fontSize: "0.8rem",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      fontSize: "0.8rem",
    }),
  };

  //   useEffect(() => {
  //     const fetchLoadData = async (id1) => {
  //       const token =
  //         "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiNjc4OGRjMGFlMDZiNDdkNjM5NjkwNmZmIiwiZW1haWwiOiJzZWRoYWwuc29uaUBjbG91ZHN0YWtlcy5jb20iLCJpYXQiOjE3Mzc1MjM0NzYsImV4cCI6MTc0MDExNTQ3Nn0.9W4-b8dSRk50xkXlysbc26GMVHm9wR1H_eUSyHljJ2A";
  //       try {
  //         const response = await axios.post(
  //           `http://localhost:9003/api/company/ltms/get/load/${id1}`,
  //           {},
  //           {
  //             headers: {
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  //         if (response.status === 200) {
  //           const {
  //             fromCity,
  //             toCity,
  //             loadingDate,
  //             productType,
  //             bodyType,
  //             tyre,
  //             truckCapacity,
  //             vehicleSize,
  //             OfferedRate,
  //             remarks,
  //           } = response.data;

  //           console.log(
  //             fromCity,
  //             toCity,
  //             loadingDate,
  //             productType,
  //             bodyType,
  //             tyre,
  //             truckCapacity,
  //             vehicleSize,
  //             OfferedRate,
  //             remarks
  //           );

  //           //   setOrigin({
  //           //     lat: fromCity.coordinates[0],
  //           //     lng: fromCity.coordinates[1],
  //           //   });
  //           //   setOriginAddress(fromCity.name);
  //           //   setDestination({
  //           //     lat: toCity.coordinates[0],
  //           //     lng: toCity.coordinates[1],
  //           //   });

  //           //   setDestinationAddress(toCity.name);
  //           setLoadingDate(loadingDate);
  //           setProductTypes(productType);
  //           setBodyTypes(bodyType);
  //           setTyreSizes(tyre);
  //           setTruckCapacities(truckCapacity);
  //           setVehicleSize(vehicleSize);
  //           setRate(OfferedRate);
  //           setRemark(remarks);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching load data:", error);
  //       }
  //     };

  //     const id1 = "67908ccc1c0860a4f8e73753";
  //     fetchLoadData(id1);
  //   }, []);

  useEffect(() => {
    // Fetch dynamic data when the form loads
    const fetchDropdownData = async () => {
      try {
        const response = await post("/company/ltms/get-ProductType", {});
        const response1 = await post("/company/ltms/get-BodyType", {});
        const response2 = await post("/company/ltms/get-TyreSize", {});

        if (response.status == 200) {
          const formattedData = response.data.map((item) => ({
            value: item.value,
            label: item.label,
            id: item._id,
          }));

          setProductTypes(formattedData);
        }
        if (response1.status === 200) {
          const formattedData = response1.data.map((item) => ({
            value: item.value,
            label: item.label,
            id: item._id,
          }));

          setBodyTypes(formattedData);
        }
        if (response2.status === 200) {
          const formattedData = response2.data.map((item) => ({
            value: item.value,
            label: item.label,
            id: item._id,
          }));

          setTyreSizes(formattedData);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchDropdownData();
  }, []);

  const fetchTruckCapacity = async (id) => {
    try {
      const response = await post(`/admin/ltms/get-TruckCapacity/${id}`, {});

      if (response.status === 200) {
        setTruckCapacities(
          response.data
            .filter((item) => item.tyreSize.includes(id))
            .map((item) => ({
              value: item.value,
              label: item.label,
              id: item._id,
            }))
        );
      }
    } catch (error) {
      console.log(error.message || "error while fetching Truck Capacities");
    }
  };

  const fetchVehicleSize = async (id) => {
    try {
      const response = await post(`/admin/ltms/get-VehicleSize/${id}`, {});
      if (response.status === 200) {
        const formattedData = response.data
          .filter((item) => item.tyreSize.includes(id))
          .map((item) => ({
            value: item.value,
            label: item.label,
            id: item._id,
          }));
        setVehicleSize(formattedData);
      }
    } catch (error) {
      console.log(error.message || "error while fetching Truck Capacities");
    }
  };

  const handleChange = (selectedOption, type) => {
    if (type == "BodyType") {
      setSelectedBodyType(selectedOption);
    } else if (type == "ProductType") {
      setSelectedProduct(selectedOption);
    } else if (type == "TyreType") {
      setSelectedTyre(selectedOption);
      setSelectedTruckCapacity({
        value: "truck_capacity",
        label: "Truck Capacity",
      });
      setSelectedVehicleSize({
        value: "vehicle_size",
        label: "Vehicle Size",
      });
      fetchTruckCapacity(selectedOption.id);
    } else if (type == "TruckCapacity") {
      setSelectedTruckCapacity(selectedOption);
      fetchVehicleSize(selectedTyre.id);
    } else if (type == "vehicleSize") {
      setSelectedVehicleSize(selectedOption);
    }
  };

  const updateLoad = async () => {
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiNjc4OGRjMGFlMDZiNDdkNjM5NjkwNmZmIiwiZW1haWwiOiJzZWRoYWwuc29uaUBjbG91ZHN0YWtlcy5jb20iLCJpYXQiOjE3Mzc1MjM0NzYsImV4cCI6MTc0MDExNTQ3Nn0.9W4-b8dSRk50xkXlysbc26GMVHm9wR1H_eUSyHljJ2A";
    const response = await axios.post(
      `http://localhost:9003/api/company/ltms/update/load/${id}`,
      {
        fromCity: {
          name: originAddress,
          coordinates: [origin.lat, origin.lng],
        },
        toCity: {
          name: destinationAddress,
          coordinates: [destination.lat, destination.lng],
        },
        loadType: "FTL",
        loadingDate: loadingDate,
        productType: selectedProduct._id,
        bodyType: selectedBodyType._id,
        tyre: selectedTyre._id,
        truckCapacity: selectedTruckCapacity._id,
        vehicleSize: selectedVehiclesize._id,
        OfferedRate: rate,
        remarks: remark,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Include Bearer Token in headers
        },
      }
    );
    if (response.status === 200) {
      console.log("Load Updated Successfully");
    }
  };
  return (
    <>
      <div className="tripCalculatorWrapper">
        <div className="row">
          <div className="col-md-7 col-lg-7">
            <div className="tripForm1">
              <div className="row" style={{ padding: "10px" }}>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Select Origin</p>
                    <div className="selectWrapperFull">
                      <AutocompleteInput
                        name="origin"
                        value={originAddress}
                        onPlaceSelected={handlePlaceSelected}
                        onChange={(e) => setOriginAddress(e.target.value)}
                        className="userInput"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Select Destination</p>
                    <div className="selectWrapperFull">
                      <AutocompleteInput
                        name="destination"
                        value={destinationAddress}
                        onPlaceSelected={handlePlaceSelected}
                        onChange={(e) => setDestinationAddress(e.target.value)}
                        className="userInput"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Enter Loading Date</p>
                    <div className="selectWrapperFull">
                      <DatePicker
                        selected={loadingDate}
                        onChange={(date) => setLoadingDate(date)}
                        showTimeSelect
                        timeFormat="HH:mm"
                        maxDate={Date.now()}
                        dateFormat={"dd/MM/yyyy hh:mm"}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Enter Delivery Date</p>
                    <div className="selectWrapperFull">
                      <DatePicker
                        selected={deliveryDate}
                        onChange={(date) => setDeliveryDate(date)}
                        showTimeSelect
                        timeFormat="HH:mm"
                        dateFormat={"dd/MM/yyyy hh:mm"}
                        placeholder="Delivery Date"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Enter Product Type</p>
                    <div className="selectWrapperFull">
                      <Select
                        value={selectedProduct}
                        onChange={(e) => handleChange(e, "ProductType")}
                        options={productTypes}
                        defaultValue={{
                          value: "Toll_Type",
                          label: "Select Vehicle Toll Type",
                        }}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Select Body Type</p>
                    <div className="selectWrapperFull">
                      <Select
                        value={selectedBodyType}
                        onChange={(e) => handleChange(e, "BodyType")}
                        options={bodyTypes}
                        defaultValue={{
                          value: "Toll_Type",
                          label: "Select Vehicle Toll Type",
                        }}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Select Tyre Type</p>
                    <div className="selectWrapperFull">
                      <Select
                        value={selectedTyre}
                        onChange={(e) => handleChange(e, "TyreType")}
                        options={tyreSizes}
                        defaultValue={{
                          value: "Toll_Type",
                          label: "Select Vehicle Toll Type",
                        }}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">
                      Select Truck Capacity
                    </p>
                    <div className="selectWrapperFull">
                      <Select
                        value={selectedTruckCapacity}
                        onChange={(e) => handleChange(e, "TruckCapacity")}
                        options={truckCapacities}
                        defaultValue={{
                          value: "Toll_Type",
                          label: "Select Vehicle Toll Type",
                        }}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Select Vehicle Size</p>
                    <div className="selectWrapperFull">
                      <Select
                        value={selectedVehiclesize}
                        onChange={(e) => handleChange(e, "vehicleSize")}
                        options={vehicleSize}
                        defaultValue={{
                          value: "Toll_Type",
                          label: "Select Vehicle Toll Type",
                        }}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Enter Rate</p>
                    <div className="selectWrapperFull">
                      <input
                        placeholder="Offered Rate"
                        value={rate}
                        onChange={(e) => setRate(e.target.value)}
                        className="userInput"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-16 col-lg-16">
                  <div className="formInputWrapper">
                    <p className="reportsFormLabel mb-1">Remark</p>
                    <div className="">
                      {/* selectedVehiclesize */}
                      <textarea
                        placeholder="Remark"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        className="userInput"
                      />
                    </div>
                  </div>
                </div>
                <div className="btnFlex">
                  <div className="btn-wrapper-trip" onClick={updateLoad}>
                    <a className="reportGenBtn">Submit</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 col-lg-5" style={{ padding: "10px" }}>
            <RouteMap
              origin={{ lat: origin.lat, lng: origin.lng }}
              destination={{ lat: destination.lat, lng: destination.lng }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateLoadForm;
